<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12" class="mt-20">
                <gofix-tab
                        :data="tabData"
                        :query-param="{id:311}"
                        arrows >
                    <template slot="gofixTab:contract_info">
                        <gofix-card title="This is Title 1" collapse>
                            <gofix-text-field class="mb-3" label="This is label">This is value</gofix-text-field>
                            <gofix-text-field label="This is label"  oneline>This is value</gofix-text-field>
                            <template slot="gofixCard:right_header">
                                <gofix-button class="mr-3" label="Button 1" @click="visible = true"></gofix-button>
                                <gofix-button class="mr-3" label="Button 2" outline></gofix-button>
                                <gofix-button class="mr-3" label="Button 3"></gofix-button>
                                <gofix-button label="Button 4" outline></gofix-button>
                            </template>
                        </gofix-card>
                        <gofix-card title="This is Title 1">
                            <gofix-text-field class="mb-3" label="This is label">This is value</gofix-text-field>
                            <gofix-text-field label="This is label"  oneline>This is value</gofix-text-field>
                            <template slot="gofixCard:right_header">
                                <gofix-button class="mr-3" label="Button 1"></gofix-button>
                                <gofix-button class="mr-3" label="Button 2" outline></gofix-button>
                                <gofix-button class="mr-3" label="Button 3"></gofix-button>
                                <gofix-button label="Button 4" outline></gofix-button>
                            </template>
                        </gofix-card>
                        <gofix-card fullContent>
                            <gofix-table :settings="tableConfig"
                                         :table-items="tableItems"
                                         @load-items="getTableData"
                                         ref="gofixTable">
                            </gofix-table>
                        </gofix-card>
                    </template>

                    <template slot="gofixTab:service_category">
                        <gofix-tab :data="tabDataChild">
                            <template slot="gofixTab:child_tab_1">
                                <gofix-card fullContent>
                                    <gofix-table :settings="tableConfig"
                                                 :table-items="tableItems"
                                                 @load-items="getTableData"
                                                 ref="gofixTable">
                                    </gofix-table>
                                </gofix-card>
                            </template>
                            <template slot="gofixTab:child_tab_2">
                                <gofix-card title="This is Title 1" >
                                    This is content 1
                                    <template slot="gofixCard:right_header">
                                        <gofix-button class="mr-3" label="Button 1"></gofix-button>
                                        <gofix-button class="mr-3" label="Button 2" outline></gofix-button>
                                        <gofix-button class="mr-3" label="Button 3"></gofix-button>
                                        <gofix-button label="Button 4" outline></gofix-button>
                                    </template>
                                </gofix-card>
                            </template>
                        </gofix-tab>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'tabs',
        components: {

        },
        data () {
            return {
                tabData:[
                    {
                        key: "contract_info",
                        title: "contract info",
                        active: true,
                        //link: "/v2/contract-client/{id}"
                    },
                    {
                        key: "service_category",
                        title: "service category",
                        active: false,
                        //link: "/v2/contract-client/{id}/service-category"
                    },
                    {
                        key: "sla",
                        title: "SLA",
                        active: false,
                        link: "/v2/contract-client/{id}/sla"
                    },
                    {
                        key: "properties",
                        title: "Properties",
                        active: false,
                        link: "/v2/contract-client/{id}/properties"

                    },
                    {
                        key: "equipment",
                        title: "equipment",
                        active: false,
                        link: "/v2/contract-client/{id}/equipment"
                    },
                    {
                        key: "sor",
                        title: "SOR",
                        active: false,
                        link: "/v2/contract-client/{id}/sor"
                    },
                    {
                        key: "maintainence_program",
                        title: "maintainence Program",
                        active: false,
                        link: "/v2/contract-client/{id}/maintenance-program",
                    },
                    {
                        key: "fm_officers",
                        title: "FM officers",
                        active: false,
                        link: "/v2/contract-client/{id}/fm-officers",
                    },
                    {
                        key: "client_staff",
                        title: "client staff",
                        active: false,
                        link: "/v2/contract-client/{id}/client-staff",
                    },
                    {
                        key: "checklist_temp",
                        title: "checklist  temp.",
                        active: false,
                        link: "/v2/contract-client/{id}/checklist-template",
                    },
                    {
                        key: "approval",
                        title: "approval",
                        active: false,
                        link: "/v2/contract-client/{id}/approval",

                    },
                    {
                        key: "finance",
                        title: "Finance",
                        active: false,
                        link: "/v2/contract-client/{id}/fm-codes",
                    }
                ],
                tabDataChild:[
                    {
                        key: "child_tab_1",
                        title: "Child Tab 1",
                        active: true,
                    },
                    {
                        key: "child_tab_2",
                        title: "Child Tab 2",
                        active: false,
                    }
                ],
                tableConfig:{
                    name: 'unit-test',
                    controls:{},
                    filter: {},
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "do_number",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'column_1',
                            label: 'Column 1',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            with:100,
                            sorting: false,
                        },
                        {
                            key: 'column_2',
                            label: 'Column 2',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            with:100,
                            sorting: false,
                        },
                        {
                            key: 'column_3',
                            label: 'Column 3',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            with:100,
                            sorting: false,
                        },
                        {
                            key: 'column_4',
                            label: 'Column 4',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            with:100,
                            sorting: false,
                        },
                        {
                            key: 'column_5',
                            label: 'Column 5',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            with:100,
                            sorting: false,
                        },
                        {
                            key: 'column_6',
                            label: 'Column 6',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:200px",
                            with:100,
                            sorting: false,
                        },
                        {
                            key: 'column_7',
                            label: 'Column 7',
                            isActive: 1,
                            isFilter: false,
                            thStyle: "width:auto",
                            with:null,
                            sorting: false,
                        }
                    ]
                },
                tableItems: [],
                visible:false
            }
        },
        created () {

        },
        methods:{
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                this.tableItems = [
                    {
                        column_1:"Value 1",
                        column_2:"Value 1",
                        column_3:"Value 1",
                        column_4:"Value 1",
                        column_5:"Value 1",
                        column_6:"Value 1",
                        column_7:"Value 1",
                    },{
                        column_1:"Value 2",
                        column_2:"Value 2",
                        column_3:"Value 2",
                        column_4:"Value 2",
                        column_5:"Value 2",
                        column_6:"Value 2",
                        column_7:"Value 2",
                    },
                    {
                        column_1:"Value 3",
                        column_2:"Value 3",
                        column_3:"Value 3",
                        column_4:"Value 3",
                        column_5:"Value 3",
                        column_6:"Value 3",
                        column_7:"Value 3",
                    },
                    {
                        column_1:"Value 4",
                        column_2:"Value 4",
                        column_3:"Value 4",
                        column_4:"Value 4",
                        column_5:"Value 4",
                        column_6:"Value 4",
                        column_7:"Value 4",
                    },
                    {
                        column_1:"Value 5",
                        column_2:"Value 5",
                        column_3:"Value 5",
                        column_4:"Value 5",
                        column_5:"Value 5",
                        column_6:"Value 5",
                        column_7:"Value 5",
                    }
                ];
                this.tableConfig.total = 5;
                resolve({
                    items: this.tableItems,
                    total: 5
                });
            }
        }
    }
</script>
